export default __webpack_public_path__ + "static/media/handsome-man-with-laptop-removebg-preview 1.a57a9e0e.svg";